import { SELECIONAR_ENCOMENDA } from '../types'

export default function buscarEncomenda (encomenda) {
  return {
    type: SELECIONAR_ENCOMENDA,
    payload: encomenda
  }
}
